(() => {
    const loginInputs = document.querySelectorAll('.LoginPage__Label');
    Array.prototype.forEach.call(loginInputs, (input) => {
        input.addEventListener('keydown', function () {
            input.classList.remove('LoginPage__Label--Error');
        });
    });
})();
